module.exports = __webpack_public_path__ + "img/07.5b7be990.jpg";